module.exports = __webpack_public_path__ + "static/Metropolis-ExtraLight-51277044b42a094cbec1a34b32f55e88.woff";